import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TicketKind } from '@work4all/models/lib/Classes/TicketKind.entity';

import { IFilterPickerConfig } from '../../../../components/entity-picker/components/list-entity-picker';
import { TicketKindPicker } from '../../../../components/entity-picker/TicketKindPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type ITicketKindFilterCard = {
  title: string;
  value: TicketKind[] | null;
  onChange: (value: TicketKind[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
  filterConfig?: IFilterPickerConfig;
};

export function TicketKindFilterCard(props: ITicketKindFilterCard) {
  const { title, value, onChange, expanded, onExpandedChange, filterConfig } =
    props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <TicketKindPicker
        layout="advanced"
        multiple={true}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        filterConfig={filterConfig}
      />
    </FilterCard>
  );
}
